// frontend/src/components/Login.js
import React, { useState } from 'react';
import axios from '../api';
import Loader from './Loader';

function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  
  const validateForm = () => {
    const newErrors = {};
    
    if (!username.trim()) {
      newErrors.username = 'Username is required';
    }
    
    if (!password) {
      newErrors.password = 'Password is required';
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      return;
    }
    
    setLoading(true);
    
    try {
      const res = await axios.post('/login', { username, password });
      localStorage.setItem('token', res.data.token);
      
      setTimeout(() => {
        window.location = '/dashboard';
      }, 1500);
    } catch (err) {
      setLoading(false);
      const errorMsg = err.response?.data?.error || 'Invalid credentials';
      setErrors({ submit: errorMsg });
    }
  };

  if (loading) return <Loader />;

  return (
    <div className="parallax-bg">
      <FloatingTexts />
      <div className="neon-form-container">
        <form onSubmit={handleSubmit} className="neon-form">
          <h2>Welcome Back</h2>
          <p className="subtitle">Sign in to access your dashboard</p>
          
          <div style={{ marginBottom: '1.25rem' }}>
            <input
              type="text"
              placeholder="Username"
              value={username}
              onChange={(e) => {
                setUsername(e.target.value);
                if (errors.username) setErrors({ ...errors, username: '' });
              }}
              style={{
                borderColor: errors.username ? '#ff4444' : 'rgba(255, 255, 255, 0.1)'
              }}
            />
            {errors.username && (
              <p style={{ 
                color: '#ff4444', 
                fontSize: '0.85rem', 
                marginTop: '0.5rem',
                marginLeft: '0.25rem'
              }}>
                {errors.username}
              </p>
            )}
          </div>
          
          <div style={{ marginBottom: '1.25rem' }}>
            <input
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => {
                setPassword(e.target.value);
                if (errors.password) setErrors({ ...errors, password: '' });
              }}
              style={{
                borderColor: errors.password ? '#ff4444' : 'rgba(255, 255, 255, 0.1)'
              }}
            />
            {errors.password && (
              <p style={{ 
                color: '#ff4444', 
                fontSize: '0.85rem', 
                marginTop: '0.5rem',
                marginLeft: '0.25rem'
              }}>
                {errors.password}
              </p>
            )}
          </div>
          
          {errors.submit && (
            <p style={{ 
              color: '#ff4444', 
              fontSize: '0.9rem', 
              marginBottom: '1rem',
              textAlign: 'center',
              padding: '0.75rem',
              background: 'rgba(255, 68, 68, 0.1)',
              borderRadius: '8px',
              border: '1px solid rgba(255, 68, 68, 0.3)'
            }}>
              {errors.submit}
            </p>
          )}
          
          <button type="submit" className="neon-button">
            <span className="text">Log In</span>
          </button>
          
          <div className="auth-switch">
            Don't have an account? <a href="/signup">Sign Up</a>
          </div>
        </form>
      </div>
    </div>
  );
}

// Floating finance-related texts component
function FloatingTexts() {
  const texts = [
    'TRANSACTIONS', 'EXPENSES', 'CREDIT SCORE', 'BALANCE', 
    'STATEMENTS', 'ANALYTICS', 'PAYMENTS', 'SAVINGS',
    'BUDGET', 'INVOICE', 'CASHFLOW', 'INTEREST',
    'MERCHANT', 'DEBIT', 'REVENUE', 'PORTFOLIO'
  ];
  
  return (
    <div className="floating-texts">
      {texts.map((text, index) => (
        <div
          key={index}
          className="float-text"
          style={{
            left: `${Math.random() * 90}%`,
            animationDelay: `${Math.random() * 20}s`,
            animationDuration: `${15 + Math.random() * 10}s`
          }}
        >
          {text}
        </div>
      ))}
    </div>
  );
}

export default Login;